import React from 'react';
import { Link } from 'react-router';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import findRoute from 'new/routing/routes';
import LinkButton from 'new/components/LinkButton';

type Props = {
  isBreakLine?: boolean;
  isAfterDeadline?: boolean;
  onClick?: () => void;
};

const StyledLinkButton = styled(LinkButton)({
  div: {
    display: 'inline',
  },
});

export const BillingIssueInfo: React.FC<Props> = ({
  isBreakLine,
  isAfterDeadline,
  onClick,
}) => {
  const renderLink = () =>
    onClick ? (
      !isAfterDeadline && (
        <StyledLinkButton
          to={findRoute('BillingPage').path as string}
          onClick={onClick}
        >
          Click to resolve.
        </StyledLinkButton>
      )
    ) : (
      <Link to={findRoute('BillingPage').path as string}>
        Click to resolve.
      </Link>
    );

  return (
    <Box textAlign="center">
      There was a billing issue
      {isBreakLine && <br />} with your latest invoice.
      {isBreakLine && <br />}
      {renderLink()}
    </Box>
  );
};

export default BillingIssueInfo;
